var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GestionTicketsPostventa',{attrs:{"modo-ticketera":"reparacion0km"}})
}
var staticRenderFns = []

export { render, staticRenderFns }